<script lang="ts">
  import { page } from '$app/stores';
  import ListLinks from './list-links.svelte';
  import type { InstitutionsReadStoreConfigurationsResponse } from '@do/shop-api';

  const links = [
    {
      text: 'About',
      link: '/about-us',
    },
    {
      link: `/contact-us`,
      text: 'contact us',
    },
    {
      link: `https://digitaloriginal.app/privacy-policy`,
      text: 'Privacy Policy',
      target: '_blank',
    },
    {
      link: `https://digitaloriginal.app/terms-and-conditions`,
      text: 'Terms and Conditions',
      target: '_blank',
    },
    {
      link: `https://digitaloriginal.app/terms-of-service`,
      text: 'Terms of Service',
      target: '_blank',
    },
  ];

  $: socialLinks = $page.data.configurations
    .social_profiles as InstitutionsReadStoreConfigurationsResponse['social_profiles'];
  $: preparedSocial = socialLinks
    ? socialLinks
        .filter((item) => item.type !== 'site')
        .map((item) => ({
          link: item.value,
          text: item.type,
          target: '_blank',
        }))
    : [];
</script>

<section class="flex flex-col gap-12 md:w-full md:flex-row md:justify-between">
  <ListLinks {links} title="Links" />

  {#if preparedSocial.length > 0}
    <ListLinks links="{preparedSocial}" title="Connect with us" />
  {/if}
</section>
